import React, { useState } from "react";

const TopBarContext = React.createContext([{}, () => {}]);

const initialState = {
    onStreamsClick: null,
    onAnalyticsClick: null,
    onRecorderClick: null,
    onAddUsersClick: null,
    onCampaignDetailsClick: null,
};

const TopBarProvider = (props) => {
    const [state, setState] = useState(initialState);

    return (
        <TopBarContext.Provider value={[state, setState]}>
            {props.children}
        </TopBarContext.Provider>
    );
};

export { TopBarContext, TopBarProvider };
